// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconFilledSavePin = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.988 8.65a2.075 2.075 0 00-.595-1.693l-5.348-5.348a2.075 2.075 0 00-3.218.353l-3.543 5.569a7.586 7.586 0 00-5.09.919l-.003.001a2.075 2.075 0 00-.415 3.26l3.26 3.26-6.829 6.83a.702.702 0 10.993.992l6.83-6.83 3.261 3.263h.001a2.075 2.075 0 003.258-.415l.002-.003a7.586 7.586 0 00.919-5.09l5.568-3.543c.53-.338.88-.899.948-1.524z"
      fill="currentColor"
    />
  );
export default SvgIconFilledSavePin;
